/**
 * GDPR / Google Consent Mode v2 helper.
 *
 * - Reads consent from localStorage (key: 'cookie_consent').
 * - Provides gtag consent defaults/update for analytics_storage, ad_storage etc.
 * - Used by useGoogleAnalytics, CookieConsent and analytics utils.
 */

export const CONSENT_KEY = 'cookie_consent';

/** @returns {'granted' | 'denied' | null} */
export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

/** @returns {boolean} true when the user has explicitly granted analytics consent */
export const hasAnalyticsConsent = () => getConsent() === 'granted';

/**
 * Push Google Consent Mode v2 **default** values.
 * Call this BEFORE any gtag('config',…) or gtag('js',…) so that Google
 * knows the initial consent state and applies modelled (cookieless) behaviour.
 */
export const setConsentDefaults = () => {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500, // ms – how long to wait for an update call
  });
};

/**
 * Push Google Consent Mode v2 **update** values.
 * Call this when the user explicitly accepts / rejects.
 */
export const setConsentUpdate = (granted) => {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('consent', 'update', {
    analytics_storage: granted ? 'granted' : 'denied',
    ad_storage: granted ? 'granted' : 'denied',
    ad_user_data: granted ? 'granted' : 'denied',
    ad_personalization: granted ? 'granted' : 'denied',
  });
};
